
<template>
    <div>
        <compWrapper title="基本信息" theme="primary">
            <compFormQuery v-if="type == 'query'" :formdata="getBase" :value="formData" align="center"></compFormQuery>
            <compFormEdit v-else ref="relation" class="margin-layout" :formdata="getBase" v-model="formData" />
        </compWrapper>
        <compWrapper title="操作历史" theme="gray" v-if="query">
            <compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
        </compWrapper>
        <div class="text-right">
            <vButton v-if="type !== 'query'" theme="primary" @click="submit">保存</vButton>
            <vButton class="margin-left-10" @click="cancel">返回</vButton>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>

import { HttpGetDataConfigOne, HttpSaveDataConfigOne, HttpGetOurWarehouseList, HttpGetDataConfigQuery } from "@/service/bespeak";
import { mapGetters } from "vuex";

export default {
    props: ['activeid', 'querytype'],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            loading: false,
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            opLogList: [],
            formData: {
                status: 0,
                reserveHour: '0',
            },
            ourwarehouseList: []
        }
    },
    created() {
        this.query = this.type === "query";
        if (this.type == 'edit' || this.type == 'query') {
            this.getDetail()
        }
        // 请求仓库
        HttpGetOurWarehouseList().then(res => {
            this.ourwarehouseList = res.data.map(item => {
                return {
                    value: item.id,
                    label: item.code + '(' + item.title + ')'
                }
            })
        })
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusWareList']),
        getBase() {
            return [
                {
                    label: '仓库',
                    tag: 'vSelect',
                    key: 'warehouseId',
                    options: this.ourwarehouseList,
                    props: {
                        filterable: true,
                    },
                    query: this.type != 'add',
                },

                {
                    label: '预约类型',
                    tag: 'vSelect',
                    key: 'goodTypeCode',
                    options: [
                        { label: "FCL", value: 'FCL' },
                        { label: "LTL", value: 'LTL' },
                        { label: "Express", value: 'Express' },
                    ],
                    props: {
                        clearable: true,
                        multiple: this.type == 'add' ? true : false,
                    },
                    query: this.type != 'add',
                },
                {
                    label: "可约日期",
                    key: "reserveTime",
                    tag: "vDatepicker",
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    valueText: this.formData.reserveDate,
                    query: this.type != 'add',
                },
                {
                    label: '单据类型',
                    tag: 'vSelect',
                    key: 'bookingType',
                    options: [
                        { label: "加急", value: '0' },
                        { label: "普通", value: '1' },
                    ],
                    props: {
                        clearable: true,
                        multiple: this.type == 'add' ? true : false,
                    },
                    query: this.type != 'add',
                },
                {
                    label: "可约量/天",
                    key: "totalQty",
                    tag: "vInput",
                },
                {
                    label: '可约时间段',
                    tag: 'vSelect',
                    key: 'reserveHour',
                    options: [
                        { label: "09:00:00-14:00:00", value: '0' },
                    ],
                    props: {
                        clearable: true,
                    },

                },
                {
                    label: '是否包含节假日',
                    show: this.type == 'add',
                    tag: 'vSelect',
                    key: 'isContainHolidayAndWeek',
                    options: [
                        { label: "是", value: '1' },
                        { label: "否", value: '0' },
                    ],
                    props: {
                        clearable: true,
                    },

                },
                {
                    label: '是否启用',
                    key: 'status',
                    tag: "vSwitch",
                    required: false,
                    props: {
                        trueValue: 1,
                        falseValue: 0
                    }
                },
            ];
        },
    },
    methods: {
        async getDetail() {
            this.loading = true;
            HttpGetDataConfigOne({
                id: this.id
            }).then(res => {
                this.formData = res.data
                this.formData.reserveHour = 0;
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
            });
            // 请求日志
            if (this.type == 'query') {
                HttpGetDataConfigQuery({
                    id: this.id
                }).then(res => {
                    this.opLogList = res.data.fbbOpLogEntityList
                })

            }
        },
        submit() {
            // 可约时间的日期赋值
            if (this.type == 'add') {
                this.formData.reserveStartDate = this.formData.reserveTime.split('~')[0]
                this.formData.reserveEndDate = this.formData.reserveTime.split('~')[1]

                this.formData.goodTypeCodeList = this.formData.goodTypeCode;
                this.formData.bookingTypeList = this.formData.bookingType;
                // this.formData.startHour = '09:00:00';
                // this.formData.endHour = '14:00:00';
                // if(this.formData.reserveHour.length>1){
                this.formData.reserveHourList = [
                    {
                        startHour: '09:00:00',
                        endHour: '14:00:00'
                    },
                ]
                // }
                // else{
                //     // 时间段赋值 编辑
                //     if(this.formData.reserveHour[0] == 0){
                //         this.formData.reserveHourList = [
                //         {
                //             startHour: '09:00:00',
                //             endHour: '12:00:00'
                //         },
                //     ]
                //     }else{
                //         this.formData.reserveHourList = [
                //         {
                //             startHour: '12:00:00',
                //             endHour: '14:00:00'
                //         },
                //     ]
                //     }
                // }
                delete this.formData.goodTypeCode;
                delete this.formData.bookingType;
            } else {

                // 时间段赋值 编辑
                // if(this.formData.reserveHour == 0){
                //     this.formData.startHour = '09:00:00';
                //     this.formData.endHour = '12:00:00';
                // }else{
                //     this.formData.startHour = '12:00:00';
                //     this.formData.endHour = '14:00:00';
                // }
                this.formData.startHour = '09:00:00';
                this.formData.endHour = '14:00:00';
            }
            delete this.formData.reserveTime;
            delete this.formData.reserveHour;
            this.loading = true;
            HttpSaveDataConfigOne({
                ...this.formData
            }).then(res => {
                this.loading = false
                this.$VMessage.success(res.message)
                this.cancel()
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                this.loading = false
            })
        },
        cancel() {
            this.$router.push({ name: "dataconfigList" });
        }
    },
}
</script>
